import api from "../axiosClient";

export async function sendFeedback(feedback, email) {
  let body = { feedback: feedback, email: email };
  let { data } = await api.post("/feedback", body);
  return data;
}
